import React from "react";
import { scroller } from "react-scroll";

export function parseTextWithLinks(text, contentData, setActiveSection) {
  if (!text) return text;

  const regex = /\{link:([a-zA-Z0-9_-]+)\}/g;

  const parts = [];
  let lastIndex = 0;
  let match;

  while ((match = regex.exec(text)) !== null) {
    const section = match[1];

    // текст до {link:...}
    parts.push(text.slice(lastIndex, match.index));

    if (contentData[section]) {
      parts.push(
        <span
          key={match.index}
          className="text-blue-600 underline cursor-pointer hover:text-blue-800"
          onClick={() => {
            setActiveSection(section);

            scroller.scrollTo(section, {
              duration: 800,
              smooth: "easeInOutQuart",
              offset: -20,
            });
          }}
        >
          {contentData[section].button}
        </span>
      );
    } else {
      parts.push(match[0]);
    }

    lastIndex = regex.lastIndex;
  }

  parts.push(text.slice(lastIndex));

  return parts;
}
